import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    deliveryReports: [],
    deliveryReportsDocTypes: [],
    deliveryReportsBatchList: [],
    deliveryReportsSendStatusList: []
};

const getters = {
    getDeliveryReports: (state) => state.deliveryReports,
    getDeliveryReportsDocTypes: (state) => state.deliveryReportsDocTypes,
    getDeliveryReportsBatchList: (state) => state.deliveryReportsBatchList,
    getDeliveryReportsSendStatusList: (state) => state.deliveryReportsSendStatusList
};

const actions = {
  async getDeliveryReports( context, data ) {
    await axios.post(`${backendUrl()}/getDeliveryReports`, data, {
        headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
    })
    .then(response => {
        context.commit('setDeliveryReports', response.data)
    })
},

    async getDeliveryReportsFilters(context) {
      await axios.post(`${backendUrl()}/getDeliveryReportsFilters`, null,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setDeliveryReportsDocumentTypes', response.data.documentTypes)
          context.commit('setDeliveryReportsBatchList', response.data.batchList)
          context.commit('setDeliveryReportSendStatusList', response.data.sendStatusList)
      })
    },

    async getEmailInfoDetails(context, data) {
        return await axios.post(`${backendUrl()}/getDeliveryReportsEmailDetails`, 
        {
            hashMsg: data
        }, 
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    // NS-10086 Function to send a request to remove email from blacklist, PW
    async sendBlacklistEmailUnlockRequest(context, data) {
        return await axios.post(`${backendUrl()}/sendBlacklistEmailUnlockRequest`, data, 
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    },
    
    async downloadBasicReport(context, data) {
        return await axios.post(`${backendUrl()}/downloadBasicReport`, data, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async downloadDetailedReport(context, data) {
        return await axios.post(`${backendUrl()}/downloadDetailedReport`, data, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    // EIPP-74 Function to request CSV report, PW
    async requestDetailedCSVReport(context, data) {
        return await axios.post(`${backendUrl()}/requestDetailedCSVReport`, data, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    }
    
};

const mutations = {
    setDeliveryReports: (state, deliveryReports) => (state.deliveryReports = deliveryReports),
    setDeliveryReportsDocumentTypes: (state, docTypes) => (state.deliveryReportsDocTypes = docTypes),
    setDeliveryReportsBatchList: (state, batchList) => (state.deliveryReportsBatchList = batchList),
    setDeliveryReportSendStatusList: (state, statusList) => (state.deliveryReportsSendStatusList = statusList)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
